import React from 'react';
import { Box, Button, Typography, SxProps, Theme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useHeader } from '../../../contexts/HeaderContext';
import { useTenant } from '../../../contexts/TenantContext';

interface OverviewHeaderActionsProps {
  sx?: SxProps<Theme>;
}

/**
 * OverviewHeaderActions component
 * Displays the "Add New Listing" button and properties count
 * Designed to be used in the overview page for specific tenants
 */
const OverviewHeaderActions: React.FC<OverviewHeaderActionsProps> = ({
  sx,
}) => {
  const { headerData } = useHeader();
  const { isAddEditHost } = useTenant();

  // Check if tenant is Bright (not AddEdit host)
  const isBrightTenant = !isAddEditHost();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        ...sx,
      }}
    >
      {/* Add New Listing Button */}
      {headerData.showAddListingButton && headerData.onAddListing && (
        <Button
          variant="contained"
          size="medium"
          startIcon={<AddIcon />}
          onClick={headerData.onAddListing}
          sx={{
            borderRadius: '8px',
            fontWeight: 600,
            textTransform: 'none',
          }}
        >
          Add New Listing
        </Button>
      )}

      {/* Properties Count - Only show for Bright tenants */}
      {isBrightTenant && headerData.propertiesCount !== undefined && (
        <Typography
          variant="body1"
          color="text.primary"
          sx={{ fontWeight: 500 }}
        >
          {headerData.propertiesCount}{' '}
          {headerData.propertiesCount === 1 ? 'property' : 'properties'} found
        </Typography>
      )}
    </Box>
  );
};

export default OverviewHeaderActions;
